"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section data-section-id="92147" id="begin-your-journey" className="dark bg-background text-foreground w-full overflow-hidden">
      <div className="grid grid-cols-1 md:grid-cols-2 w-full">
        {}
        <div className="relative min-h-[400px] md:min-h-[600px] w-full">
          <img src="https://milehighcavaliers.10web.cloud/wp-content/uploads/2026/03/IMG_5072-1.jpg" alt="Premium Cavalier King Charles Spaniel" className="absolute inset-0 w-full h-full object-contain" />
        </div>

        {}
        
      </div>
    </section>;
}